'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDocument$002dKind$0024 from "./presto.types$-Document-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$60() {
  this.aHE = null;
  this.aHC = null;
  this.aHD = false;
  this.aHA = null;
  this.aHB = false;
  this.aHF = false;
  this.aHG = false;
  this.aHE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$60 as $c_Lpresto_CredentialsView$$anon$60 };
$p = $c_Lpresto_CredentialsView$$anon$60.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$60;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$60() {
}
export { $h_Lpresto_CredentialsView$$anon$60 as $h_Lpresto_CredentialsView$$anon$60 };
$h_Lpresto_CredentialsView$$anon$60.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aHE;
});
$p.t = (function() {
  if ((!this.aHD)) {
    this.aHC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHD = true;
  }
  return this.aHC;
});
$p.ag = (function() {
  if ((!this.aHB)) {
    this.aHA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDocument$002dKind$0024.$m_Lpresto_types$DocumentKind$().ae5()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHB = true;
  }
  return this.aHA;
});
$p.v = (function() {
  if ((!this.aHG)) {
    this.aHF = false;
    this.aHG = true;
  }
  return this.aHF;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$60, "presto.CredentialsView$$anon$60", ({
  G9: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$60 as $d_Lpresto_CredentialsView$$anon$60 };
//# sourceMappingURL=presto.-Credentials-View$$anon$60.js.map
